jQuery(document).ready(function () {
    const block = jQuery('.mainbanner-block');
    if (!block.length) {
        return;
    }

    new Swiper('.mainbanner-block .swiper', {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        pagination: {
            el: '.mainbanner-block .slider-navs__pag',
            type: 'bullets',
            clickable: true,
            renderBullet: function (_index, className) {
                return '<span class="' + className + '"><span></span></span>';
            }
        },
        autoplay: {
            delay: 5000,
            pauseOnMouseEnter: true
        },
        on: {
            beforeInit: function () {
                block.find('.swiper-slide').css('display', '');
                block.find('.swiper').css('max-height', '').css('overflow', '');
            },
            autoplayTimeLeft: (_swiper, _timeLeft, percentage) => {
                jQuery('.mainbanner-block .swiper-pagination-bullet-active span').width(
                    Math.ceil(100 * percentage) + '%'
                );
            }
        }
    });
});
